import { c as _c } from "react/compiler-runtime";
import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { IconStar } from "@tabler/icons-react";
interface Props {
  item: CartItemOutputDto;
}
export function DiscountSitewidePromo(t0) {
  const $ = _c(10);
  const {
    item
  } = t0;
  if (!item.siteWideDiscountAmount) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center space-x-2"><IconStar size={16} /><p className="font-medium">Sitewide Promotion</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== item.siteWideDiscountDescription) {
    t2 = <div className="flex flex-col">{t1}<p className="text-sm text-neutral-500">{item.siteWideDiscountDescription}</p></div>;
    $[1] = item.siteWideDiscountDescription;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.siteWideDiscountAmount) {
    t3 = CurrencyFormatter.formatUSD(item.siteWideDiscountAmount);
    $[3] = item.siteWideDiscountAmount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `-${t3}`;
  let t5;
  if ($[5] !== t4) {
    t5 = <p className="text-base font-medium text-green-600">{t4}</p>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className="flex justify-between">{t2}{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}